import {media_with_details} from "@core/gql-mockups/media";

export const blog_page = `{
    id
    title
    summary
    description
    category {
        title
        id
        seo{
            url
            title
            full_url
        }
    }
    media ${media_with_details}
    media_gallery {
        url
        alt
    }
    user {
        full_name
        email
        seo {
            full_url
        }
        media {
            url
            alt
        }
   }
    publishAt
    updatedAt
    seo {
        url
        full_url
        description
        keywords
    }
}`


export const blog_card = `{
    id
    title
    createdAt
    publishAt
    summary
    user {
        full_name
        seo {
            full_url
        }
        media {
            url
            alt
        }
    }
    media {
        alt
        url
    }
    seo {
        url
        full_url
    }
}`;
  